import React from 'react';

export default function BoxItemPlaceholder({ children }) {
  return <span className="text-muted">{children}</span>;
}
